// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEvent } from './AuditEvent';
import {
  AuditEventFromJSON,
  AuditEventFromJSONTyped,
  AuditEventToJSON,
  AuditEventToJSONTyped,
} from './AuditEvent';

/**
 *
 * @export
 * @interface AuditEventList
 */
export interface AuditEventList {
  /**
   *
   * @type {Array<AuditEvent>}
   * @memberof AuditEventList
   */
  items?: Array<AuditEvent>;
  /**
   *
   * @type {string}
   * @memberof AuditEventList
   */
  nextPageToken?: string;
}

/**
 * Check if a given object implements the AuditEventList interface.
 */
export function instanceOfAuditEventList(
  value: object,
): value is AuditEventList {
  return true;
}

export function AuditEventListFromJSON(json: any): AuditEventList {
  return AuditEventListFromJSONTyped(json, false);
}

export function AuditEventListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuditEventList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(AuditEventFromJSON),
    nextPageToken:
      json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function AuditEventListToJSON(json: any): AuditEventList {
  return AuditEventListToJSONTyped(json, false);
}

export function AuditEventListToJSONTyped(
  value?: AuditEventList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(AuditEventToJSON),
    next_page_token: value['nextPageToken'],
  };
}
